module.exports = __webpack_public_path__ + "static/media/vinsen-2.4ed7dca5.jpg";